import React from "react";

interface SidebarDisplayAreaContentProps {
  children?: React.ReactNode;
}

const SidebarDisplayAreaContent: React.FC<SidebarDisplayAreaContentProps> = ({
  children,
}) => {
  return <div className="sidebar-display-area-content">{children}</div>;
};

export default SidebarDisplayAreaContent;
